import randomSubset from '../randomSubset';

function PaintBoxes(minigameData, state){
    const colors = randomSubset(minigameData.data.colors, state.objects.difficulty ? 6 : 3);
	const coloredBoxCount = colors.map(({ count }) => count).reduce((a, b) => a + b, 0);
	const boxCount = Math.floor(coloredBoxCount * (1 + 0.1 * Math.random()));
	return {
		colors,
		boxCount,
		title: minigameData.title,
	}
}

export default PaintBoxes;